import React from "react";
import SceneLevelItem from "./SceneLevelItem";
import SceneLevelGroup from "./SceneLevelGroup";

const SceneLevelsList = props => {
  const { items, getSceneImages, type, getStepConfiguration, getItemByAlias, config } = props;

  const renderLevels = (item, setting) => {
    if (type === "default"){
      const defaultImgAlias = item.defaultImgAlias;
      if (defaultImgAlias) {
        return item.steps.map((step, index) => {
          return (
            <SceneLevelItem
              key={`level-${item.name}-${index}`}
              img={getSceneImages(defaultImgAlias)}
            />
          );
        });
      } else {
        return <div></div>
      }
    } else {
      return item.steps.map((step, index) => {
        if (setting) {
          const imgAlias = setting.configuration[index].configuration.imgAlias;
          const itemInfo = getItemByAlias(setting.configuration[index].name)
          const defaultImg = itemInfo.defaultImg;
          let img;
          if (config.currentStep >= itemInfo.stepNum && config.completedStep >= itemInfo.stepNum - 1){
            img = item.showDefault && !imgAlias ? getSceneImages(defaultImg) : getSceneImages(imgAlias);
          } else {
            img = imgAlias ? getSceneImages(imgAlias) : null
          }
          if (img) {
            return (
              <SceneLevelItem
                key={`level-${step}`}
                img={img}
              />
            )
          } else {

          }
        }
      });
    }
  };

  const renderLevelGroups = () => {
    return items.map((item, index) => {
      const setting = getStepConfiguration(item.alias)
      return <SceneLevelGroup key={`group-${item.name}`}>{renderLevels(item, setting, index)}</SceneLevelGroup>;
    });
  };

  const renderContents = () => {
    if (items && items.length) {
      return renderLevelGroups();
    } else {
      return <div>nessun livello caricato</div>;
    }
  };

  return <div className="scene-level-list">{renderContents()}</div>;
};

export default SceneLevelsList;
